<template>
  <div>
    <v-card elevation="2" class="pa-4">
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="headline">{{ album.title }}</span>
        <v-btn icon @click="refreshMedia">
          <v-icon>mdi-sync</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <image-uploader @refresh="$emit('refresh')" :albumId="album.id" @uploaded="refreshMedia" />

        <v-row dense class="mt-4">
          <v-col v-for="media in mediaItems" :key="media.id" cols="12" sm="6" md="4" lg="3">
            <v-hover v-slot="{ hover }">
              <v-card class="overflow-hidden" max-width="100%" raised>
                <v-img :src="media.baseUrl + '=w400-h400'" aspect-ratio="1" class="transition-swing">
                  <template v-slot:placeholder>
                    <v-skeleton-loader type="image"></v-skeleton-loader>
                  </template>
                </v-img>

                <v-fade-transition mode="out-in">
                  <div v-if="hover" class="overlay d-flex align-center justify-center">
                    <v-btn icon color="red lighten-2" @click.stop="deleteMedia(media.id)">
                      <v-icon large>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-fade-transition>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "@/api"
import imageUploader from "./imageUploader.vue"

export default {
  name: "AlbumDetail",
  components: { imageUploader },
  props: ["album"],
  data() {
    return {
      mediaItems: [],
      loading: false,
    }
  },
  methods: {
    async refreshMedia() {
      this.loading = true
      try {
        this.mediaItems = await api.display.fetchAlbum(this.album.id)
      } finally {
        this.loading = false
      }
    },
    async deleteMedia(id) {
      if (confirm("Bild wirklich löschen?")) {
        try {
          await api.display.deletePhoto(id, this.album.id)
          await this.refreshMedia()
          this.$emit("refresh")
        } catch (e) {
          console.error(e)
          this.$toast.error("Löschen fehlgeschlagen.")
        }
      }
    },
  },
  created() {
    this.refreshMedia()
  },
}
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.transition-swing {
  transition: transform 0.3s ease;
}
.v-card:hover .transition-swing {
  transform: scale(1.05);
}
</style>
